import urls from '@/networkRequests/apiClient/endpoints'

import { configureRequest, replacePathVariables } from '../../../../../networkRequests/apiClient/apiClient.functions'
import { getUserRoleForBackend } from '../../../../../shared/functions/UserRole/userRoleManagment.functions'
import {
  GetFulfillmentOrderDetailsForAdminErrorResponse,
  GetFulfillmentOrderDetailsForAdminRequest,
  GetFulfillmentOrderDetailsForAdminSuccessResponse
} from './getFulfillmentOrderDetailsForAdmin.types'

export const getFulfillmentOrderDetailsForAdminApi = async (
  request: GetFulfillmentOrderDetailsForAdminRequest
): Promise<GetFulfillmentOrderDetailsForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.admin.getFulfillmentOrderDetailsForAdmin, { orderId: request.orderId }),
    method: 'GET',
    headers: {
      'X-User-Role': getUserRoleForBackend()
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetFulfillmentOrderDetailsForAdminSuccessResponse
  } else {
    throw response as GetFulfillmentOrderDetailsForAdminErrorResponse
  }
}

export default getFulfillmentOrderDetailsForAdminApi
